var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isAMP)?_c('audio',{attrs:{"id":"notificationSound","src":"/consultations/audio/notification.mp3","preload":"auto"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }